<template>
  <!-- Template-level CTA (decision #5): on every guide, after the intro and at the end; not author-controlled -->
  <aside class="guide-cta" aria-label="Create a Memorial">
    <p class="guide-cta-head">Honouring someone of your own?</p>
    <p>Create a free memorial page — share one link, and everyone adds their own photos and stories.</p>
    <a class="btn btn-primary" href="/who" @click.prevent="createMemorial">Create a Memorial</a>
  </aside>
</template>

<script setup>
import { useStartMemorial } from '../../composables/useStartMemorial'

const { createMemorial } = useStartMemorial()
</script>
